/** Strip .html / .php from the address bar when the server already served the page. */
export function preferCleanPath(): void {
  if (typeof window === 'undefined') return;
  if (window.location.protocol !== 'http:' && window.location.protocol !== 'https:') return;

  const { pathname, search, hash } = window.location;
  let next = pathname;

  if (next === '/index.html' || next.endsWith('/index.html')) {
    next = next.slice(0, -'index.html'.length) || '/';
  } else if (next.endsWith('/color.html') || next.endsWith('/color.php')) {
    next = next.replace(/\/color\.(html|php)$/, '/color');
  } else if (next === '/color.html' || next === '/color.php') {
    next = '/color';
  } else {
    return;
  }

  if (next !== pathname) {
    window.history.replaceState(null, '', `${next}${search}${hash}`);
  }
}
